import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelUirule.mjs'
import SrcType from '../components/SrcType.mjs'
import UiruleType from './UiruleType.jsx'

const PropertiesPaneUirule = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <Text prop="ruleTitle" />
                <Text prop="ruleUserCode" />

                <Select
                    options={UiruleType}
                    prop="ruleType"
                />

                <Select
                    options={SrcType}
                    prop="srcType"
                />

                <TagSelect prop="ruleKey" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    //'Depend',
                    'Effect',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneUirule
